export const THEME_IDS = [
  "dark",
  "retro-blue",
  "amber",
  "green",
  "solarized",
  "catppuccin-latte",
  "catppuccin-mocha",
  "ms-edit-light",
  "solarized-light",
  "gruvbox-light",
  "tokyo-night-day",
  "tokyo-night-moon",
] as const;

export const FONT_IDS = [
  "dos",
  "jetbrains-mono",
  "ibm-plex-mono",
  "fira-code",
  "source-code-pro",
  "system-mono",
] as const;

export type ThemeId = (typeof THEME_IDS)[number];
export type FontId = (typeof FONT_IDS)[number];

export const DEFAULT_THEME: ThemeId = "ms-edit-light";
export const DEFAULT_FONT: FontId = "system-mono";
export const THEME_STORAGE_KEY = "turbonotes2-color-theme";
export const FONT_STORAGE_KEY = "turbonotes2-editor-font";

export const THEME_COLORS: Record<ThemeId, string> = {
  dark: "#0c0c0c",
  "retro-blue": "#000080",
  amber: "#0d0800",
  green: "#000d00",
  solarized: "#002b36",
  "catppuccin-latte": "#eff1f5",
  "catppuccin-mocha": "#1e1e2e",
  "ms-edit-light": "#f4f1e8",
  "solarized-light": "#fdf6e3",
  "gruvbox-light": "#fbf1c7",
  "tokyo-night-day": "#e1e2e7",
  "tokyo-night-moon": "#222436",
};

interface StorageReader {
  getItem(key: string): string | null;
}

export interface Appearance {
  theme: ThemeId;
  font: FontId;
}

export function isThemeId(value: string | null): value is ThemeId {
  return value !== null && (THEME_IDS as readonly string[]).includes(value);
}

export function isFontId(value: string | null): value is FontId {
  return value !== null && (FONT_IDS as readonly string[]).includes(value);
}

export function loadAppearance(storage: StorageReader): Appearance {
  const storedTheme = storage.getItem(THEME_STORAGE_KEY);
  const storedFont = storage.getItem(FONT_STORAGE_KEY);
  return {
    theme: isThemeId(storedTheme) ? storedTheme : DEFAULT_THEME,
    font: isFontId(storedFont) ? storedFont : DEFAULT_FONT,
  };
}
